import {
  NlpModel,
  PromptAnswerSchema,
  PromptStepSchema,
  QuestionAnswerSchema,
  QuestionStepSchema
} from '@feedyou/schema'

export function replaceIntentIdsWithAnswers(
  model: NlpModel,
  questionLikeStep: QuestionStepSchema | PromptStepSchema
): NlpModel {
  return {
    ...model,
    intents: model?.intents?.map(intent => {
      // @ts-ignore https://github.com/microsoft/TypeScript/issues/33591#issuecomment-786443978
      const correspondingAnswer = questionLikeStep.answers?.find(
        (answer: QuestionAnswerSchema | PromptAnswerSchema) => answer.id === intent.id
      )

      return {
        ...intent,
        id: correspondingAnswer?.answer || correspondingAnswer?.id || intent.id
      }
    })
  }
}
